import React, { useState } from "react";

import { Input, Button, Text } from "@fragments";

import * as Material from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';

export default function Components() {
    const longText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

    // Input states
    const [textInput, setTextInput] = useState("");
    const [emailInput, setEmailInput] = useState("");
    const [fullNameInput, setFullNameInput] = useState("");
    const [phoneInput, setPhoneInput] = useState("");
    const [dateInput, setDateInput] = useState("");
    const [cpfInput, setCpfInput] = useState("");
    const [cnpjInput, setCnpjInput] = useState("");
    const [moneyInput, setMoneyInput] = useState("");
    const [integerInput, setIntegerInput] = useState("");
    const [selectInput, setSelectInput] = useState("");
    const [selectOptionsInput, setSelectOptionsInput] = useState([]);
    const [multilineInput, setMultilineInput] = useState("");
    const [emojiInput, setEmojiInput] = useState("");

    // Switch states
    const [switch1, setSwitch1] = useState(false);
    const [switch2, setSwitch2] = useState(true);
    const [switch3, setSwitch3] = useState(false);

    // Select options
    const selectOptions = [
        { label: "Opção 1", value: "option1", icon: <StarIcon /> },
        { label: "Opção 2", value: "option2", icon: <FavoriteIcon /> },
        { label: "Opção 3", value: "option3" },
    ];

    const multiSelectOptions = [
        { label: "JavaScript", value: "js" },
        { label: "TypeScript", value: "ts" },
        { label: "Python", value: "py" },
        { label: "Java", value: "java" },
        { label: "C#", value: "csharp" },
        { label: "Go", value: "go" },
        { label: "Rust", value: "rust" },
    ];

    return (
        <div style={{ padding: "40px", display: "flex", width: "100%", flexDirection: "column", gap: "60px", maxWidth: "900px", margin: "0 auto" }}>

            {/* Section 1: All Text Variants */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Text Variants</h2>
                <Text.h1>Heading 1 - League Spartan</Text.h1>
                <Text.h2>Heading 2 - League Spartan</Text.h2>
                <Text.h3>Heading 3 - League Spartan</Text.h3>
                <Text.h4>Heading 4 - League Spartan</Text.h4>
                <Text.h5>Heading 5 - League Spartan</Text.h5>
                <Text.h6>Heading 6 - League Spartan</Text.h6>
                <Text.p>Paragraph text - League Spartan</Text.p>
                <Text.span>Span text - League Spartan</Text.span>
            </div>

            {/* Section 2: Contrast Levels */}
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <h2 style={{ marginBottom: "10px" }}>Contrast Levels (1-9)</h2>
                <Text.h4 contrast={1}>Contrast 1 (default) - Lightest</Text.h4>
                <Text.h4 contrast={2}>Contrast 2</Text.h4>
                <Text.h4 contrast={3}>Contrast 3</Text.h4>
                <Text.h4 contrast={4}>Contrast 4</Text.h4>
                <Text.h4 contrast={5}>Contrast 5</Text.h4>
                <Text.h4 contrast={6}>Contrast 6</Text.h4>
                <Text.h4 contrast={7}>Contrast 7</Text.h4>
                <Text.h4 contrast={8}>Contrast 8</Text.h4>
                <Text.h4 contrast={9}>Contrast 9 - Darkest</Text.h4>
            </div>

            {/* Section 3: Left and Right Icons */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Left & Right Icons</h2>

                <Text.h1 grow left={<StarIcon />}>
                    H1 with left icon
                </Text.h1>

                <Text.h2 grow right={<FavoriteIcon />}>
                    H2 with right icon
                </Text.h2>

                <Text.h3 left={<StarIcon />} right={<FavoriteIcon />}>
                    H3 with both icons
                </Text.h3>

                <Text.h4 left={<StarIcon />} contrast={5}>
                    H4 with left icon and contrast 5
                </Text.h4>

                <Text.h5 right={<FavoriteIcon />} contrast={7}>
                    H5 with right icon and contrast 7
                </Text.h5>

                <Text.p left={<StarIcon />}>
                    Paragraph with left icon
                </Text.p>

                <Text.span right={<FavoriteIcon />}>
                    Span with right icon
                </Text.span>
            </div>

            {/* Section 4: Gap Sizes (h1-h3 use gap-2, h4-span use gap-1) */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Gap Sizes (Large vs Small)</h2>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h1 left={<StarIcon />} grow right={<StarIcon />}>
                        H1 uses var(--gap-2) - larger gap
                    </Text.h1>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h2 left={<StarIcon />} right={<StarIcon />}>
                        H2 uses var(--gap-2) - larger gap
                    </Text.h2>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h3 left={<StarIcon />} right={<StarIcon />}>
                        H3 uses var(--gap-2) - larger gap
                    </Text.h3>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h4 left={<StarIcon />} right={<StarIcon />}>
                        H4 uses var(--gap-1) - smaller gap
                    </Text.h4>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h5 left={<StarIcon />} right={<StarIcon />}>
                        H5 uses var(--gap-1) - smaller gap
                    </Text.h5>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.p left={<StarIcon />} right={<StarIcon />}>
                        Paragraph uses var(--gap-1) - smaller gap
                    </Text.p>
                </div>

                <div style={{ padding: "10px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.span left={<StarIcon />} right={<StarIcon />}>
                        Span uses var(--gap-1) - smaller gap
                    </Text.span>
                </div>
            </div>

            {/* Section 5: MaxLines Truncation */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>MaxLines Truncation (using TruncableText)</h2>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h4 maxLines={2} contrast={3}>
                        {longText}
                    </Text.h4>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.p maxLines={3} contrast={4}>
                        {longText}
                    </Text.p>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h5 maxLines={1} contrast={5}>
                        {longText}
                    </Text.h5>
                </div>
            </div>

            {/* Section 6: MaxLines with Icons */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>MaxLines with Icons</h2>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h4 maxLines={2} left={<StarIcon />} contrast={4}>
                        {longText}
                    </Text.h4>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.p maxLines={2} right={<FavoriteIcon />} contrast={5}>
                        {longText}
                    </Text.p>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h5 maxLines={3} left={<StarIcon />} right={<FavoriteIcon />} contrast={6}>
                        {longText}
                    </Text.h5>
                </div>
            </div>

            {/* Section 7: Combined Features */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Combined Features</h2>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h1 left={<StarIcon />} contrast={8}>
                        Featured Title with Icon
                    </Text.h1>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.h3 right={<FavoriteIcon />} contrast={6}>
                        Subtitle with Right Icon
                    </Text.h3>
                </div>

                <div style={{ padding: "15px", backgroundColor: "var(--surface-10)", borderRadius: "8px" }}>
                    <Text.p left={<StarIcon />} maxLines={2} contrast={4}>
                        {longText}
                    </Text.p>
                </div>
            </div>

            {/* Section 8: Input Variants - Basic Inputs */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Basic Inputs</h2>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <Input.Text
                        value={textInput}
                        onInput={setTextInput}
                        label="Text Input"
                        placeholder="Digite qualquer texto"
                        helper="Input de texto básico"
                    />

                    <Input.Text
                        value={textInput}
                        onInput={setTextInput}
                        label="Text Input com limite"
                        placeholder="Máximo 50 caracteres"
                        size={50}
                        helper="Limitado a 50 caracteres"
                    />

                    <Input.Email
                        value={emailInput}
                        onInput={setEmailInput}
                        label="Email"
                        placeholder="exemplo@email.com"
                        helper="Formato de email válido"
                    />

                    <Input.FullName
                        value={fullNameInput}
                        onInput={setFullNameInput}
                        label="Nome Completo"
                        placeholder="Digite seu nome completo"
                        helper="Capitalização automática"
                    />

                    <Input.Integer
                        value={integerInput}
                        onInput={setIntegerInput}
                        label="Número Inteiro"
                        placeholder="Digite apenas números"
                        max={10}
                        helper="Apenas números, máximo 10 dígitos"
                    />
                </div>
            </div>

            {/* Section 9: Input Variants - Formatted Inputs */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Formatted Inputs</h2>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <Input.Phone
                        value={phoneInput}
                        onInput={setPhoneInput}
                        label="Telefone"
                        helper="Formato: +55 (00) 00000-0000"
                    />

                    <Input.Date
                        value={dateInput}
                        onInput={setDateInput}
                        label="Data"
                        helper="Formato: dd/mm/aaaa"
                    />

                    <Input.CPF
                        value={cpfInput}
                        onInput={setCpfInput}
                        label="CPF"
                        helper="Formato: 000.000.000-00"
                    />

                    <Input.CNPJ
                        value={cnpjInput}
                        onInput={setCnpjInput}
                        label="CNPJ"
                        helper="Formato: 00.000.000/0000-00"
                    />

                    <Input.Money
                        value={moneyInput}
                        onInput={setMoneyInput}
                        label="Valor em Reais"
                        helper="Formato: R$ 0,00"
                    />
                </div>
            </div>

            {/* Section 10: Input Variants - Select Inputs */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Select Inputs</h2>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <Input.Select
                        value={selectInput}
                        onInput={setSelectInput}
                        label="Select Simples"
                        placeholder="Selecione uma opção"
                        options={selectOptions}
                        helper="Dropdown com ícones"
                    />

                    <Input.SelectOptions
                        value={selectOptionsInput}
                        onInput={setSelectOptionsInput}
                        label="Multi-Select"
                        placeholder="Selecione múltiplas opções"
                        options={multiSelectOptions}
                        helper="Selecione várias linguagens"
                    />

                    <Input.SelectOptions
                        value={selectOptionsInput}
                        onInput={setSelectOptionsInput}
                        label="Multi-Select com limite"
                        placeholder="Máximo 3 itens"
                        options={multiSelectOptions}
                        maxItems={3}
                        helper="Máximo de 3 seleções"
                    />

                    <Input.SelectOptions
                        value={selectOptionsInput}
                        onInput={setSelectOptionsInput}
                        label="Multi-Select com novos valores"
                        placeholder="Digite para adicionar"
                        options={multiSelectOptions}
                        allowNewValues={true}
                        helper="Permite adicionar novos valores"
                    />
                </div>
            </div>

            {/* Section 11: Input Variants - Special Features */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Special Features</h2>

                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <Input.Text
                        value={multilineInput}
                        onInput={setMultilineInput}
                        label="Multiline Input"
                        placeholder="Digite múltiplas linhas..."
                        multiline
                        helper="Input com múltiplas linhas (auto-resize)"
                    />

                    <Input.Text
                        value={emojiInput}
                        onInput={setEmojiInput}
                        label="Input com Emoji"
                        placeholder="Digite texto e adicione emojis"
                        emoji
                        helper="Clique no ícone para adicionar emojis"
                    />

                    <Input.Text
                        value={emojiInput}
                        onInput={setEmojiInput}
                        label="Multiline com Emoji"
                        placeholder="Múltiplas linhas com emojis"
                        multiline
                        emoji
                        helper="Combina multiline e emoji picker"
                    />

                    <Input.Text
                        value={textInput}
                        onInput={setTextInput}
                        label="Input com ícones"
                        placeholder="Input com start e end icons"
                        start={<StarIcon />}
                        end={<FavoriteIcon />}
                        helper="Ícones personalizados no início e fim"
                    />

                    <Input.Text
                        value=""
                        onInput={() => { }}
                        label="Input Desabilitado"
                        placeholder="Este input está desabilitado"
                        disabled
                        helper="Estado desabilitado"
                    />

                    <Input.Text
                        value="Texto com erro"
                        onInput={() => { }}
                        label="Input com Erro"
                        placeholder="Input com estado de erro"
                        error
                        helper="Este campo contém um erro"
                    />
                </div>
            </div>

            {/* Section 12: Input Variants - Variant Sizes */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Size Variants</h2>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                    <Input.Text
                        value={textInput}
                        onInput={setTextInput}
                        label="Variant Light (padrão)"
                        placeholder="Input com variant light"
                        variant="light"
                        helper="Variante light (padrão)"
                    />

                    <Input.Text
                        value={textInput}
                        onInput={setTextInput}
                        label="Variant Large"
                        placeholder="Input com variant large"
                        variant="large"
                        helper="Variante large"
                    />
                </div>
            </div>

            {/* Section 13: Input Variants - Switch */}
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <h2 style={{ marginBottom: "10px" }}>Input Variants - Switch</h2>

                <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <Input.Switch
                        checked={switch1}
                        onInput={setSwitch1}
                        label="Switch simples"
                    />

                    <Input.Switch
                        checked={switch2}
                        onInput={setSwitch2}
                        label="Switch ativado por padrão"
                    />

                    <Input.Switch
                        checked={switch3}
                        onInput={setSwitch3}
                        left={<StarIcon />}
                        label="Switch com ícone à esquerda"
                    />

                    <Input.Switch
                        checked={switch1}
                        onInput={setSwitch1}
                        label="Switch com ícone à direita"
                        right={<FavoriteIcon />}
                    />

                    <Input.Switch
                        checked={switch2}
                        onInput={setSwitch2}
                        left={<StarIcon />}
                        label="Switch com ambos os ícones"
                        right={<FavoriteIcon />}
                    />

                    <Input.Switch
                        checked={true}
                        onInput={() => { }}
                        label="Switch desabilitado"
                        disabled
                    />
                </div>
            </div>

        </div>
    );
}
